<template>
    <v-dialog value="true" max-width="400px">
        <v-card
            :loading="loading"
        >
            <v-card-title>
                <span class="headline">
                <v-icon>mdi-alert</v-icon>
                    You've been disconnected
                </span>
            </v-card-title>
        </v-card>
    </v-dialog>

</template>
<script>
    export default {
        name: 'LogoutComponent ',
        mounted() {
            this.$store.dispatch('auth/logout')
                .then(()=>{
                    this.loading = false
                })
        },
        data: () => ({
            loading: true
        })
    }
</script>
